import { render, staticRenderFns } from "./ContactDialog.vue?vue&type=template&id=1a781e3c&"
import script from "./ContactDialog.vue?vue&type=script&lang=ts&"
export * from "./ContactDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ContactDialog.vue?vue&type=style&index=0&id=1a781e3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports